

































import { i18n } from '@/i18n';
import { defineComponent, ref, nextTick, watchEffect, watch, onMounted, computed } from '@vue/composition-api';

/** 事件keys */
const gEmitKeys = {
  /** 点击输入框 */
  click: 'click',
  /** 点击取消按钮 */
  cancel: 'cancel',
  /** 输入变化 */
  input: 'input',
  /** 点击搜索 */
  search: 'search',
  /** 清空 */
  clear: 'clear',
};

export default defineComponent({
  props: {
    preventDefault: {
      type: Boolean,
      default: false,
    },
    keyword: {
      type: String,
      default: '',
    },
    inputTip: {
      type: String,
      default: i18n('搜索商戶名稱領優惠'),
    },
  },
  emits: Object.values(gEmitKeys),
  setup(props, { emit }) {
    const refInput = ref<HTMLElement>();
    const isInputActive = ref(false);
    /** 输入的搜索关键字 */
    const searchWord = ref('');

    const searchBtnLabel = computed(() => props.inputTip + i18n('雙擊搜索'));

    /** 外部输入关键字 */
    watchEffect(() => {
      if (props.preventDefault || !props.keyword) return;
      searchWord.value = props.keyword;
      // focusInput();
      isInputActive.value = true;
    });

    /** 重置输入框 */
    function resetSearch() {
      isInputActive.value = false;
      searchWord.value = '';
    }

    /** 聚焦输入框 */
    function focusInput() {
      isInputActive.value = true;
      // 要放在下一帧，否则会出现跟点击点抢夺焦点的情况
      nextTick(() => {
        refInput.value?.focus();
      });
    }

    /** 点击icon，展示输入框，聚焦 */
    function eClickIcon() {
      if (props.preventDefault) {
        emit(gEmitKeys.click);
        return;
      }
      focusInput();
      emit(gEmitKeys.click);
    }
    /** 点击取消，隐藏输入框 */
    function eClickBtn() {
      resetSearch();
      emit(gEmitKeys.cancel);
    }
    /** 点击clear，删除内容 */
    function eClickClear() {
      searchWord.value = '';
      refInput.value?.focus();
      emit(gEmitKeys.clear);
    }
    /** 发起搜索 */
    function eSearch() {
      const str = searchWord.value.trim();
      if (!str) return;
      emit(gEmitKeys.search, str);
      refInput.value?.blur();
    }
    /** input事件 */
    watch(searchWord, (newVal) => {
      if (!newVal) {
        // 清空了
        emit(gEmitKeys.clear);
        return;
      }
      emit(gEmitKeys.input, searchWord.value);
    });

    onMounted(() => {
      if (!props.preventDefault) {
        focusInput();
      }
    });

    return {
      refInput,
      isInputActive,
      searchWord,
      searchBtnLabel,

      eClickIcon,
      eClickBtn,
      eClickClear,
      eSearch,
    };
  },
});
